import React from "react";

import Section from "../../../HOC/Section";
import Link from "../../UI/Link/Link";

import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";

import facts from "../../../assets/img/facts_bg.jpg";
import banner1 from "../../../assets/img/banner1.jpeg";
import banner2 from "../../../assets/img/banner2.jpeg";

const home = () => {
  const slides = [
    {
      src: banner1,
      title: "Image 1 for carousel",
      description: "0000",
    },
    {
      src: "./1.jpg",
      alt: "Image 2 for carousel",
    },
    {
      src: banner2,
      alt: "Image 3 for carousel",
    },
  ];

  return (
    <Section id="home">
      <div>
        <Slider autoplay={3000}>
          {slides.map((item, index) => (
            <div
              key={index}
              style={{
                background: `url('${item.src}') no-repeat center center`,
                "-webkit-background-size": "cover",
                "-moz-background-size": "cover",
                "-o-background-size": "cover",
                "background-size": "cover",
              }}
            >
              <div className="center">
                {/* <h1>{item.title}</h1>
                <p>{item.description}</p>
                <button>{item.button}</button> */}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </Section>
  );
};

export default home;
